import { Component, ViewContainerRef, TemplateRef  } from '@angular/core';
import { Payment } from '../../models/payment/payment-model';
import { PaymentService } from '../../services/payment/payment.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileService } from '../../services/profile/profile.service';
import { Router } from "@angular/router";
import { RolePermissionService } from '../../services/role/role-permission.service';


@Component({
  selector: 'app-create-payment-method',
  templateUrl: './create-payment-method.component.html',
  styleUrls: ['./create-payment-method.component.css']
})
/** create-parent-category component*/
export class CreatePaymentMethodComponent {
  public payment = new Payment();
  fileToUpload: File;
  fd = new FormData();
  selectedPaymentLogo: string;
  validate: boolean;
  public mediaList: MediaLibrary[];
  userId: number;
  mediaImageShow: boolean;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  /** create-parent-category ctor */
  constructor(private readonly paymentService: PaymentService, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly profileService: ProfileService, private readonly mediaServices: MediaLibraryService, private modalService: BsModalService,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("paymentmethod").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.payment.isActive = true;
            this.validate = true;
            this.mediaImageShow = true;
            this.profileService.getProfile().subscribe(
              data => {
                if (data) {
                  this.userId = data.userID;
                }
                else {
                  this.userId = 0;
                }
              });

          }
          else {
            this.router.navigate(["/payment-list"]);
          }
        }
        else {
          this.router.navigate(["/payment-list"]);
        }
      }
    )
  }
  isActiveCheckbox(e) {
    this.payment.isActive = e.target.checked;
  }
  isDefualtCheckbox(e) {
    this.payment.isDefault = e.target.checked;
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.fd = new FormData();
    this.mediaImageShow = true;
    this.selectedPaymentLogo = "";
    this.payment.paymentLogo = "";
    this.payment.paymentLogo = Image.fileName;

    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });


    Image.activeDiv = !Image.activeDiv;
  }
  HidePopup() {
    this.selectedPaymentLogo = "";
    this.payment.paymentLogo = "";
    this.modalRef.hide();
  }
  ShowImage() {
    this.mediaImageShow = false;
    this.selectedPaymentLogo = "";
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  uploadPaymentLogo(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("PaymentLogo", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.payment.paymentLogo = "";
      this.mediaImageShow = true;
      this.selectedPaymentLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  onSubmit() {
    this.validate = false;
    this.paymentService.InsertPaymentMethod(this.payment).subscribe(result => {
      if (result) {
        this.toastr.success('Payment Method has been Saved.', 'Success');
        this.fd.append("PaymentID", result.toString());
        this.paymentService.AddPaymentLogo(this.fd, this.userId);
      }
      else {
        this.toastr.error('Error occurred. Please try again', 'Error');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/payment-components/create-payment-method/create-payment-method.component.ts